
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.409","height":"14.409"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-search","fill":"none","stroke":"#da581f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 588","d":"M11.662 6.331A5.331 5.331 0 116.331 1a5.331 5.331 0 015.331 5.331z"}}),_c('path',{attrs:{"data-name":"패스 589","d":"M12.995 12.995l-2.9-2.9"}})])])
          )
        }
      }
    